import React from "react";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { Btn, Eyebrow, Section, SectionTitle } from "@/components/ui-kit/Kit";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";

export const AntiCounterfeit = () => {
  const { t } = useI18n();
  const a = t("home.antiCounterfeit");

  return (
    <Section className="bg-slate-50/70 py-24 sm:py-32" data-testid="anti-counterfeit-section">
      <div className="grid gap-14 lg:grid-cols-[1fr_1.15fr] lg:gap-20">
        <Reveal>
          <Eyebrow>{a.eyebrow}</Eyebrow>
          <SectionTitle className="mt-6 max-w-[18ch]">{a.title}</SectionTitle>
          <p className="mt-7 border-l-2 border-grn pl-6 text-sm leading-relaxed text-navy/80 sm:text-base">{a.body}</p>
          <p className="mt-7 text-[13px] leading-relaxed text-slate-600">{a.fairness}</p>
          <Btn to="/anti-counterfeit" variant="outline" className="mt-9" data-testid="anti-counterfeit-link">
            {t("nav.antiCounterfeit")} <ArrowRight className="h-4 w-4" />
          </Btn>
        </Reveal>

        <div>
          <Reveal>
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-navy/40">
              Recommended safe trade discipline
            </p>
          </Reveal>
          <Stagger className="mt-7 grid gap-px border border-navy/10 bg-navy/10 sm:grid-cols-2" step={0.05}>
            {(a.discipline || []).map((d, i) => (
              <StaggerItem key={d} className="bg-white">
                <div
                  className="group flex items-center gap-4 px-6 py-5 transition-colors duration-400 hover:bg-navy"
                  data-testid={`discipline-${i + 1}`}
                >
                  <span className="font-mono text-[11px] text-grn transition-colors duration-400 group-hover:text-gold">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="font-display text-[15px] font-medium uppercase tracking-[0.04em] text-navy transition-colors duration-400 group-hover:text-white">
                    {d}
                  </span>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </div>
    </Section>
  );
};
